<input
  [id]="id"
  type="checkbox"
  class="size-[16px] rounded-[3px] border-aux-gray-dark text-aux-blue focus:ring-aux-blue"
  [ngClass]="{
    'cursor-pointer': !disabled,
    'bg-gray-100': disabled,
    'cursor-not-allowed': editMode === undefined ? disabled : editMode && disabled,
    'cursor-default': editMode === false,
  }"
  [disabled]="disabled"
  [indeterminate]="indeterminate"
  [(ngModel)]="checked"
  (ngModelChange)="customChange.emit($event); onChangeCallback?.($event)"
  [attr.data-pendo-id]="pendoTag()"
/>
@if (!hideLabel) {
  <label
    class="ml-[8px] block truncate"
    [class.cursor-pointer]="!disabled && hideLabelCursor !== true"
    [class.cursor-not-allowed]="disabled"
    [class.opacity-50]="disabled"
    [for]="id"
  >
    <ng-content></ng-content>
  </label>
}
